<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span v-if="isUpdated">{{ form.user.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group :label="$t('User')">
              <validation-provider
                #default="{ errors }"
                :name="$t('User')"
                vid="user_id"
                rules="required"
              >
                <v-select
                  v-model="form.user_id"
                  :options="additionalData.users"
                  :clearable="false"
                  label="name"
                  :reduce="_user => _user.id"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Fixed amount')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Fixed amount')"
                vid="fixed_amount"
                rules="required"
              >
                <b-form-input
                  id="fixed_amount"
                  v-model="form.fixed_amount"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Fixed amount')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Percent')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Percent')"
                vid="percent"
                rules="required"
              >
                <b-form-input
                  id="percent"
                  v-model="form.percent"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Percent')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Source')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Source')"
                vid="source"
              >
                <b-form-input
                  id="source"
                  v-model="form.source"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Source')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../../common/mixins/form'

export default {
  name: 'ResellersEditModal',
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'resellers',
      modalName: 'modal-resellers-edit',
      useRouteName: true,
      createAbleFields: [
        'user_id',
        'fixed_amount',
        'percent',
        'source',
      ],
    }
  },
}
</script>

<style scoped>

</style>
